export default __webpack_public_path__ + "static/media/SDG16.133251e3.png";